export function calculateMinerGems(miner, nowTime, levelRates = {}) {
  const MAX = 8 * 60 * 60 * 1000;
  const last = new Date(miner.lastClaimTime).getTime();
  const expiry = miner.upgradeExpiry ? new Date(miner.upgradeExpiry).getTime() : 0;
  const now = new Date(nowTime).getTime();
  
  if (now <= last) return { currentGems: 0, progressPct: 0, isFull: false };
  
  let currentGems = 0;
  let totalTimeCounted = 0;
  
  // Default fallback if levelRates is empty/missing
  if (!levelRates[1]) levelRates[1] = 30;

  if (miner.level > 1 && expiry > now) {
    totalTimeCounted = Math.min(now - last, MAX);
    const rate = levelRates[miner.level] || levelRates[1];
    currentGems = parseFloat(((totalTimeCounted / MAX) * rate).toFixed(1));
  } else if (miner.upgradeExpiry && last < expiry && now > expiry) {
    const msAtUpgrade = expiry - last;
    const msAtLevel1 = now - expiry;
    const cappedUpgrade = Math.min(msAtUpgrade, MAX);
    const rem = Math.max(0, MAX - cappedUpgrade);
    const cappedL1 = Math.min(msAtLevel1, rem);
    
    totalTimeCounted = cappedUpgrade + cappedL1;
    const rateUpgrade = levelRates[miner.level] || levelRates[1];
    const gemsUpgrade = (cappedUpgrade / MAX) * rateUpgrade;
    const gemsL1 = (cappedL1 / MAX) * levelRates[1];
    currentGems = parseFloat((gemsUpgrade + gemsL1).toFixed(1));
  } else {
    totalTimeCounted = Math.min(now - last, MAX);
    currentGems = parseFloat(((totalTimeCounted / MAX) * levelRates[1]).toFixed(1));
  }

  return {
    currentGems,
    progressPct: (totalTimeCounted / MAX) * 100,
    isFull: totalTimeCounted >= MAX,
  };
}
